import { useMemo } from 'react'
import { Project, Task } from '@/shared/types/entities'

interface ProjectTaskSelectorProps {
  projects: Project[]
  tasks: Task[]
  selectedProjectId: string | null
  selectedTaskId: string | null
  onProjectChange: (projectId: string) => void
  onTaskChange: (taskId: string | null) => void
  disabled?: boolean
}

export function ProjectTaskSelector({
  projects,
  tasks,
  selectedProjectId,
  selectedTaskId,
  onProjectChange,
  onTaskChange,
  disabled = false,
}: ProjectTaskSelectorProps) {
  const availableTasks = useMemo(() => {
    if (!selectedProjectId) return []
    return tasks.filter((t) => t.projectId === selectedProjectId && !t.isArchived)
  }, [tasks, selectedProjectId])
  
  return (
    <div className="space-y-2">
      <div>
        <label className="text-sm font-medium">Project</label>
        <select
          value={selectedProjectId || ''}
          onChange={(e) => {
            const projectId = e.target.value
            onProjectChange(projectId)
            onTaskChange(null)
          }}
          disabled={disabled}
          className="mt-1 block w-full rounded-md border border-input bg-background px-3 py-2 text-sm"
        >
          <option value="">Select a project...</option>
          {projects.map((project) => (
            <option key={project.id} value={project.id}>
              {project.name}
            </option>
          ))}
        </select>
      </div>
      
      {selectedProjectId && availableTasks.length > 0 && (
        <div>
          <label className="text-sm font-medium">Task (Optional)</label>
          <select
            value={selectedTaskId || ''}
            onChange={(e) => onTaskChange(e.target.value || null)}
            disabled={disabled}
            className="mt-1 block w-full rounded-md border border-input bg-background px-3 py-2 text-sm"
          >
            <option value="">No specific task...</option>
            {availableTasks.map((task) => (
              <option key={task.id} value={task.id}>
                {task.name}
              </option>
            ))}
          </select>
        </div>
      )}
    </div>
  )
}

export default ProjectTaskSelector
